import roadClosureIcon from "../assets/images/Synchro/events-icons/road-closure.png";
import laneClosureIcon from "../assets/images/Synchro/events-icons/lane-closure.png";
import roadworksIcon from "../assets/images/Synchro/events-icons/roadworks.png";
import tempTrafficIcon from "../assets/images/Synchro/events-icons/temporary-traffic-management-measure.png";
import bridgeClosureIcon from "../assets/images/Synchro/events-icons/bridge-closure.png";
import accidentIcon from "../assets/images/Synchro/events-icons/accident.png";
import incidentIcon from "../assets/images/Synchro/events-icons/incident.png";
import adverseDrivingIcon from "../assets/images/Synchro/events-icons/adverse-driving-conditions.png";
import weatherIcon from "../assets/images/Synchro/events-icons/severe-weather-conditions.png";
import jamIcon from "../assets/images/Synchro/events-icons/jam.png";
import defaultIcon from "../assets/images/Synchro/events-icons/defaultIconLayer.png";
import bluetoothIcon from "../assets/images/Synchro/events-icons/device_online.png";
import vmsIcon from "../assets/images/Synchro/events-icons/bilboard.png";

// map category id to icon
export const getIcon = (nameIcon) => {
  switch (nameIcon) {
    case 'roadClosure': return roadClosureIcon;
    case 'laneClosure': return laneClosureIcon;
    case 'roadworks': return roadworksIcon;
    case 'tempTraffic': return tempTrafficIcon;
    case 'bridgeClosure': return bridgeClosureIcon;
    case 'accident': return accidentIcon;
    case 'incident': return incidentIcon;
    case 'adverseDriving': return adverseDrivingIcon;
    case 'weather': return weatherIcon;
    case 'jam': return jamIcon;
    case 'bluetooth': return bluetoothIcon;
    case 'vms': return vmsIcon;
    default: return defaultIcon;
  }
};
